import {
  Box,
  Button,
  Card,
  Chip,
  Dialog,
  DialogActions,
  Stack,
  Typography,
  alpha,
  styled,
  useTheme
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { fCurrency, fNumber, fPercent } from '../../utils/formatNumber';
import trendingUpFill from '@iconify/icons-eva/trending-up-fill';
import trendingDownFill from '@iconify/icons-eva/trending-down-fill';
import { Icon } from '@iconify/react';
import { calculatePercentageVariation } from '../../utils/percentageVariations';
import ReactApexChart from 'react-apexcharts';

const IconWrapperStyle = styled('div')(({ theme }) => ({
  width: 24,
  height: 24,
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.success.main,
  backgroundColor: alpha(theme.palette.success.main, 0.16)
}));

const CardDashboard = ({
  title = 'title',
  data = [],
  children,
  mainData = undefined,
  subTitle = '',
  dataGraficas = [],
  mainDataIsPendientes = false,
  utilidad,
  isCurrency
}) => {
  const [open, setOpen] = useState(false);
  const [percentage, setPercentage] = useState();
  const CHART_DATA = [{ data: dataGraficas.slice().reverse() }];

  const theme = useTheme();

  const chartOptions = {
    colors: [theme.palette.primary.main],
    chart: { sparkline: { enabled: true } },
    plotOptions: { bar: { columnWidth: '68%', borderRadius: 2 } },
    labels: ['1', '2', '3', '4', '5', '6', '7', '8'],
    tooltip: {
      x: { show: false },
      y: {
        formatter: (seriesName) => fNumber(seriesName),
        title: {
          formatter: () => ''
        }
      },
      marker: { show: false }
    }
  };

  useEffect(() => {
    const percentageVariations = calculatePercentageVariation(dataGraficas);
    setPercentage(percentageVariations[0]);
  }, [dataGraficas]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const displayValue = () => {
    if (isCurrency) {
      return fCurrency(Number(utilidad) || 0);
    }
    if (utilidad === undefined) {
      return data.length;
    }
    return utilidad;
  };
  return (
    <Card sx={{ padding: 2, width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          cursor: 'pointer',
          alignItems: 'center'
        }}
        onClick={handleClickOpen}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="subtitle2">{title}</Typography>
          {percentage !== undefined && (
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 2, mb: 1 }}>
              <IconWrapperStyle
                sx={{
                  ...(percentage < 0 && {
                    color: 'error.main',
                    bgcolor: alpha(theme.palette.error.main, 0.16)
                  })
                }}
              >
                <Icon width={16} height={16} icon={percentage >= 0 ? trendingUpFill : trendingDownFill} />
              </IconWrapperStyle>
              <Typography component="span" variant="subtitle2">
                {percentage > 0 && '+'}
                {fPercent(percentage)}
              </Typography>
              <Typography component="span" variant="caption">
                Respecto al periodo anterior
              </Typography>
            </Stack>
          )}

          {mainDataIsPendientes ? (
            <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
              <Typography variant="h3" color="#00086e">
                {mainData.length}
              </Typography>
              {subTitle && (
                <Chip
                  label={subTitle}
                  color="error"
                  variant="outlined"
                  sx={{ borderColor: 'transparent', marginLeft: 2 }}
                />
              )}
            </Box>
          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
              <Typography variant="h3" color="#00086e">
                {displayValue()}
              </Typography>
              {subTitle && (
                <Chip
                  label={subTitle}
                  color="success"
                  variant="outlined"
                  sx={{ borderColor: 'transparent', marginLeft: 2 }}
                />
              )}
            </Box>
          )}
        </Box>
        {dataGraficas.length > 0 && (
          <ReactApexChart type="bar" series={CHART_DATA} options={chartOptions} width={50} height={36} />
        )}
      </Box>

      <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth>
        <Box>{children}</Box>
        <DialogActions>
          <Button onClick={handleClose}>Cerrar</Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default CardDashboard;
